import React from 'react';
import PropTypes from 'prop-types';
import { Translate, I18n } from 'react-redux-i18n';
import { TextCheckbox } from 'front-onceforall-core';
import { getFieldLabel } from '../../utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const links = {
  art219322: 'https://www.legifrance.gouv.fr/affichCode.do%3Bjsessionid%3DB81BA950929BDC11249DDF8C185D1DE4.tplgfr42s_2?idSectionTA=LEGISCTA000037729575&cidTexte=LEGITEXT000037701019&dateTexte=20190401',
  art239340: 'https://www.legifrance.gouv.fr/affichCode.do%3Bjsessionid%3DB81BA950929BDC11249DDF8C185D1DE4.tplgfr42s_2?idSectionTA=LEGISCTA000037728277&cidTexte=LEGITEXT000037701019&dateTexte=20190401'
};
function linkToArticles(key) {
  return /*#__PURE__*/_jsx("a", {
    href: links[key],
    target: "_blank",
    rel: "noopener noreferrer",
    children: I18n.t(`publicProcurement.assignmentOrPledge.links.${key}`)
  });
}
function AssignmentOrPledge(_ref) {
  let {
    publicProcurementData,
    onChange
  } = _ref;
  const toggleIsModificationAct = () => {
    onChange({
      isModificationAct: publicProcurementData.isModificationAct ? null : true,
      withCertificate: null
    });
  };
  const toggleIsNotModificationAct = () => {
    onChange({
      isModificationAct: publicProcurementData.isModificationAct === false ? null : false,
      withCertificate: null
    });
  };
  const toggleWithCertificate = () => {
    onChange({
      withCertificate: publicProcurementData.withCertificate ? null : true
    });
  };
  const toggleWithoutCertificate = () => {
    onChange({
      withCertificate: publicProcurementData.withCertificate === false ? null : false
    });
  };
  const displayFirstHypothesis = () => {
    const isNotModificationAct = publicProcurementData.isModificationAct === false;
    return /*#__PURE__*/_jsxs("div", {
      className: "card",
      children: [/*#__PURE__*/_jsx("div", {
        className: "pb-3",
        children: /*#__PURE__*/_jsx("h4", {
          children: /*#__PURE__*/_jsx(Translate, {
            value: "publicProcurement.assignmentOrPledge.first.title"
          })
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "row pb-3",
        children: /*#__PURE__*/_jsx("div", {
          className: "col-12",
          children: /*#__PURE__*/_jsx(TextCheckbox, {
            id: "assignmentOrPledge-first-isModificationAct",
            name: "assignmentOrPledge-first-isModificationAct",
            label: getFieldLabel('publicProcurement.assignmentOrPledge.first.isModificationAct', false),
            value: false,
            checked: isNotModificationAct,
            onChange: toggleIsNotModificationAct
          })
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: "pb-3",
        children: [/*#__PURE__*/_jsx(Translate, {
          value: "publicProcurement.assignmentOrPledge.first.details.part1"
        }), linkToArticles('art219322'), /*#__PURE__*/_jsx(Translate, {
          value: "publicProcurement.assignmentOrPledge.first.details.part2"
        }), linkToArticles('art239340'), /*#__PURE__*/_jsx(Translate, {
          value: "publicProcurement.assignmentOrPledge.first.details.part3"
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: "pl-5",
        children: [/*#__PURE__*/_jsx("div", {
          className: "pt-3",
          children: /*#__PURE__*/_jsx("h4", {
            children: /*#__PURE__*/_jsx(Translate, {
              value: "publicProcurement.assignmentOrPledge.first.certificates.title"
            })
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "row pb-3",
          children: /*#__PURE__*/_jsx("div", {
            className: "col-12",
            children: /*#__PURE__*/_jsx(TextCheckbox, {
              id: "assignmentOrPledge-first-withCertificate",
              name: "assignmentOrPledge-first-withCertificate",
              label: getFieldLabel('publicProcurement.assignmentOrPledge.first.certificates.withCertificate', false),
              value: true,
              checked: isNotModificationAct && Boolean(publicProcurementData.withCertificate),
              onChange: toggleWithCertificate,
              disabled: !isNotModificationAct
            })
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "pb-3",
          children: /*#__PURE__*/_jsx(Translate, {
            value: "publicProcurement.assignmentOrPledge.or"
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "row pb-3",
          children: /*#__PURE__*/_jsx("div", {
            className: "col-12",
            children: /*#__PURE__*/_jsx(TextCheckbox, {
              id: "assignmentOrPledge-first-withoutCertificate",
              name: "assignmentOrPledge-first-withoutCertificate",
              label: getFieldLabel('publicProcurement.assignmentOrPledge.first.certificates.withoutCertificate', false),
              value: false,
              checked: isNotModificationAct && publicProcurementData.withCertificate === false,
              onChange: toggleWithoutCertificate,
              disabled: !isNotModificationAct
            })
          })
        })]
      })]
    });
  };
  const displaySecondHypothesis = () => {
    const isModificationAct = publicProcurementData.isModificationAct;
    return /*#__PURE__*/_jsxs("div", {
      className: "card",
      children: [/*#__PURE__*/_jsx("div", {
        className: "pb-3",
        children: /*#__PURE__*/_jsx("h4", {
          children: /*#__PURE__*/_jsx(Translate, {
            value: "publicProcurement.assignmentOrPledge.second.title"
          })
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "row pb-3",
        children: /*#__PURE__*/_jsx("div", {
          className: "col-12",
          children: /*#__PURE__*/_jsx(TextCheckbox, {
            id: "assignmentOrPledge-second-isModificationAct",
            name: "assignmentOrPledge-second-isModificationAct",
            label: getFieldLabel('publicProcurement.assignmentOrPledge.second.isModificationAct', false),
            value: true,
            checked: Boolean(publicProcurementData.isModificationAct),
            onChange: toggleIsModificationAct
          })
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: "pl-5",
        children: [/*#__PURE__*/_jsx("div", {
          className: "row pb-3",
          children: /*#__PURE__*/_jsx("div", {
            className: "col-12",
            children: /*#__PURE__*/_jsx(TextCheckbox, {
              id: "assignmentOrPledge-second-withCertificate",
              name: "assignmentOrPledge-second-withCertificate",
              label: /*#__PURE__*/_jsxs("div", {
                children: [/*#__PURE__*/_jsx(Translate, {
                  value: "publicProcurement.assignmentOrPledge.second.certificates.with.part1"
                }), linkToArticles('art219322'), /*#__PURE__*/_jsx(Translate, {
                  value: "publicProcurement.assignmentOrPledge.second.certificates.with.part2"
                }), linkToArticles('art239340'), /*#__PURE__*/_jsx(Translate, {
                  value: "publicProcurement.assignmentOrPledge.second.certificates.with.part3"
                })]
              }),
              value: true,
              checked: isModificationAct && Boolean(publicProcurementData.withCertificate),
              onChange: toggleWithCertificate,
              disabled: !isModificationAct
            })
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "pb-3",
          children: /*#__PURE__*/_jsx(Translate, {
            value: "publicProcurement.assignmentOrPledge.or"
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "row pb-3",
          children: /*#__PURE__*/_jsx("div", {
            className: "col-12",
            children: /*#__PURE__*/_jsx(TextCheckbox, {
              id: "assignmentOrPledge-second-withoutCertificate",
              name: "assignmentOrPledge-second-withoutCertificate",
              label: getFieldLabel('publicProcurement.assignmentOrPledge.second.certificates.without.checkbox', false),
              value: false,
              checked: isModificationAct && publicProcurementData.withCertificate === false,
              onChange: toggleWithoutCertificate,
              disabled: !isModificationAct
            })
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "pb-3",
          children: /*#__PURE__*/_jsx(Translate, {
            value: "publicProcurement.assignmentOrPledge.second.certificates.without.part1"
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "pb-3",
          children: /*#__PURE__*/_jsx(Translate, {
            value: "publicProcurement.assignmentOrPledge.second.certificates.without.part2"
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "pb-3",
          children: /*#__PURE__*/_jsx(Translate, {
            value: "publicProcurement.assignmentOrPledge.second.certificates.without.part3"
          })
        })]
      })]
    });
  };
  return /*#__PURE__*/_jsxs("div", {
    className: "card",
    children: [/*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx("h2", {
        children: /*#__PURE__*/_jsx(Translate, {
          value: "publicProcurement.titles.assignmentOrPledge"
        })
      })
    }), displayFirstHypothesis(), displaySecondHypothesis()]
  });
}
AssignmentOrPledge.propTypes = {
  onChange: PropTypes.func.isRequired,
  publicProcurementData: PropTypes.shape({
    isModificationAct: PropTypes.bool,
    withCertificate: PropTypes.bool
  }).isRequired
};
export default AssignmentOrPledge;